import { render, staticRenderFns } from "./ManageSensorAssignmentCookingName.vue?vue&type=template&id=16130516&"
import script from "./ManageSensorAssignmentCookingName.vue?vue&type=script&lang=js&"
export * from "./ManageSensorAssignmentCookingName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports